import { render, staticRenderFns } from "./ClarityCartItem.vue?vue&type=template&id=52476d12&"
import script from "./ClarityCartItem.vue?vue&type=script&lang=ts&"
export * from "./ClarityCartItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports